import { render } from "./ClockFaceComponent.vue?vue&type=template&id=f7dd9b04"
import script from "./ClockFaceComponent.vue?vue&type=script&lang=js"
export * from "./ClockFaceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__